module.exports = __webpack_public_path__ + "img/three_2.5b27e082.png";